export default __webpack_public_path__ + "static/media/1111111.cdce8344.png";